/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const unauthorizedSchema = z
	.object({
		detail: z.string().optional().default("Учетные данные не были предоставлены."),
	})
	.describe("Сериализатор 401 ошибки - для документации.");
